var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.45215 17.2607H7.12207V18.5176C7.12207 20.2227 7.99219 21.0928 9.71484 21.0928H18.5391C20.2529 21.0928 21.1318 20.2139 21.1318 18.5176V9.64941C21.1318 7.95312 20.2529 7.08301 18.5391 7.08301H16.8691V5.81738C16.8691 4.12988 15.9902 3.25098 14.2764 3.25098H5.45215C3.72949 3.25098 2.85938 4.1123 2.85938 5.81738V14.6943C2.85938 16.3906 3.72949 17.2607 5.45215 17.2607ZM5.46973 16.1709C4.48535 16.1709 3.94922 15.6523 3.94922 14.6328V5.87891C3.94922 4.85938 4.48535 4.34082 5.46973 4.34082H14.2588C15.2256 4.34082 15.7793 4.85938 15.7793 5.87891V7.08301H9.71484C7.99219 7.08301 7.12207 7.94434 7.12207 9.64941V16.1709H5.46973ZM9.73242 20.0029C8.74805 20.0029 8.21191 19.4756 8.21191 18.4648V9.70215C8.21191 8.69141 8.74805 8.16406 9.73242 8.16406H18.5215C19.4883 8.16406 20.042 8.69141 20.042 9.70215V18.4648C20.042 19.4756 19.4883 20.0029 18.5215 20.0029H9.73242Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.70c6f03c80cdc50e6cb086a5dd910931.svg";
export { ForwardRef as ReactComponent };